angular.module('tf.services')

    .service('ProjectStorageService', ['StorageService', function(StorageService){

        var storageKey = 'project';


        this.store = function(project){
            return StorageService.store(storageKey, project);
        };
        this.load = function(){
            return StorageService.load(storageKey);
        };
        this.delete = function(){
            return StorageService.delete(storageKey);
        };

        return this;

    }]);
